module.exports = __webpack_public_path__ + "static/artist-marketing-hero-b2d1fa93309c6ff3ed13bd5a6572411c.webp";